import { isUndefined } from 'utils/tsHelpers';
import { MINIMUM, MAXIMUM } from '../constants';

export const getHasCountError = (value?: number, minValue = MINIMUM, maxValue = MAXIMUM) => {
  if (isUndefined(value)) return false;
  return value < minValue || value > maxValue;
};
